import { render, staticRenderFns } from "./orderReturnList.vue?vue&type=template&id=64ad35cb&"
import script from "./orderReturnList.vue?vue&type=script&lang=js&"
export * from "./orderReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports